import { AssistantPanel } from '@/components/dashboard/common/assistant/assistant-panel'
import { Button } from '@/components/ui/button'
import { Sparkles } from 'lucide-react'
import { useState } from 'react'

export const AssistantWidget = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        type='button'
        variant='outline'
        size='sm'
        onClick={() => setOpen(true)}
        aria-label='Open AI assistant'
        className='h-9 cursor-pointer gap-1.5 border-rose-200 bg-background px-2 font-medium text-rose-600 md:px-3 transition-colors duration-150 hover:border-rose-300 hover:bg-rose-50 hover:text-rose-700 dark:border-rose-500/30 dark:text-rose-300 dark:hover:bg-rose-500/10 dark:hover:text-rose-200'
      >
        <Sparkles className='h-4 w-4' />
        <span className='hidden md:inline'>Ask CISO</span>
      </Button>
      <AssistantPanel open={open} onOpenChange={setOpen} />
    </>
  )
}

export default AssistantWidget
